import { Box, Typography, type TypographyProps } from "@mui/material";
import type React from "react";

type AnimatedEllipsisProps = {
	displayedText: string;
	delay?: number;
} & TypographyProps;

const AnimatedEllipsis: React.FC<AnimatedEllipsisProps> = ({ delay = 0.2, displayedText = "", ...typographyProps }) => {
	// Define common style for all dots, including animation
	const dotStyle = {
		display: "inline-block",
		marginLeft: "2px",
		easing:
			"linear(0, 0.225 3%, 0.409 5.7%, 0.562 8.3%, 0.68 10.7%, 0.772 13.1%, 0.809 14.3%, 0.838 15.5%, 0.861 16.7%, 0.877 17.9%, 0.887 19.1%, 0.89 20.3%, 0.888 21.2%, 0.883 22.1%, 0.875 23%, 0.862 24%, 0.826 26%, 0.775 28.1%, 0.716 30.1%, 0.637 32.4%, 0.26 42.2%, 0.175 44.6%, 0.103 46.8%, 0.029 49.4%, -0.03 51.9%, -0.076 54.4%, -0.11 56.9%, -0.13 59%, -0.142 61.2%, -0.146 63.5%, -0.143 65.9%, -0.136 67.9%, -0.124 70.2%, -0.051 80.6%, -0.034 83.4%, -0.021 86%, -0.011 89%, -0.004 92.1%, -0.001 95.5%, 0)",
		animation: "pulse 1s infinite",
		// "@keyframes pulse": {
		//
		// 	"0%, 100%": {
		// 		opacity: 0,
		// 	},
		// 	"50%": {
		// 		opacity: 1,
		// 	},
		// },
	};

	return (
		<Typography textAlign="center" {...typographyProps}>
			{displayedText}
			<Box component="span" sx={{ ...dotStyle, animationDelay: `${0}s` }}>
				.
			</Box>
			<Box component="span" sx={{ ...dotStyle, animationDelay: `${delay}s` }}>
				.
			</Box>
			<Box component="span" sx={{ ...dotStyle, animationDelay: `${delay * 2}s` }}>
				.
			</Box>
		</Typography>
	);
};

export default AnimatedEllipsis;
